module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1600x2-c7cd499c86e796e12c5d14332f16c7a8.webp";